module.exports = __webpack_public_path__ + "img/20200609_113748.f84c8424.jpg";